<template>
<v-container fluid >
  <h1 class="ma-4 d-flex justify-center textTitle--text font-weight-black">Los productos de la Ferreteria JEAN CARLOS</h1>
   <v-row class="justify-center">
   
    <v-btn @click="manageCat" class="yellow lighten-3 ma-3 pa-3 font-weight-black black--text">{{$t('productsScreen.catButton')}}</v-btn>
     <v-btn @click="manageProp" class="pink lighten-3 ma-3 pa-3 font-weight-black black--text">{{$t('productsScreen.propsButton')}}</v-btn>
     <v-btn @click="manageFournisseur" class="orange lighten-3 ma-3 pa-3 font-weight-black black--text">{{$t('productsScreen.sellerButton')}}</v-btn>
     <v-btn class="brown lighten-3 ma-3 pa-3 font-weight-black black--text">{{$t('productsScreen.refresh')}}</v-btn>
    <v-btn
              color="success"
              class="ma-3 pa-3 font-weight-black black--text"
              @click="addProd"
            >{{ $t('productsScreen.newProdButton') }}</v-btn>

</v-row> 
  <prodFilters v-if="filtros"/>
  <v-dialog v-model="addProdDialog" width="80%" :retain-focus="false">
  <addProduct 
          @dialogend="addProdDialog=false"
          :key="prodform"
          />
  </v-dialog>
  <v-dialog v-model="manageCatDialog" width="80%" :retain-focus="false">
                 <catManager :key="catform" />
               </v-dialog>
               <v-dialog v-model="managePropDialog" width="80%" :retain-focus="false">
                 <propManager :key="propform" />
               </v-dialog>
               <v-dialog v-model="manageFournisseurDialog" width="80%" :retain-focus="false">
                      <manageFournisseur :key="buyForm"/>
                    </v-dialog>



   <productTable
   v-if="!filterTable"
   :products="prodList"
   :headers="getHeadersProps"
   />

  

    
</v-container>
</template>

<script>
import addProduct from '@/components/addProduct'
import productTable from '@/components/productTable'
import propManager from '@/components/propManager'
import catManager from '@/components/catManager'
import manageFournisseur from '@/components/manageFournisseur'
//import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
          
export default {
   // eslint-disable-next-line vue/no-unused-components
   components:{ manageFournisseur,addProduct,productTable,catManager,propManager },
    data () {
        return {
            catform:0,
            propform:0, 
            manageCatDialog:false,
            managePropDialog:false,     
            addProdDialog:false, 
            filtros:false,
            filterTable:false,
            manageFournisseurDialog:false,
            buyForm:0,
            prodform:0,
          }
    },
    computed:{
      ...mapGetters([
        'getHeadersProps',
        'prodList',
      ])
    },
    watch: {
     
    },
    mounted() {

        },
    methods:{
      
      
      manageFournisseur(){
          this.buyForm+=1;
          this.manageFournisseurDialog=true;
        },
       
        manageProp(){
        this.propform+=1
        this.managePropDialog=true
      },
      manageCat(){
        this.catform+=1
        this.manageCatDialog=true
      },
        
        addProd(){
          this.prodform+=1
          this.addProdDialog=true
        },
        

    }
}
</script>
